// COMPONENTS
import React from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { CampaignAccess, SounditiAuth } from '@sounditi/ft2-api';
import Link from './Link';
import ModalDialog from '../components/ModalDialog';
import Input from '../components/Input';
import Select from '../components/Select';
import T from '../components/Translate';

// ACTIONS
import { showNotification } from '../reducers/notifications';
import { setRedirect } from '../reducers/navigation';
import { setTestsData } from '../reducers/user';
import { postActionGTMCampaing } from '../utils/events';

// TYPES
import { newCampaignTemplateES } from '../config/campaignTemplates';
import { newCampaignTemplateEN } from '../config/campaignTemplates';
import {
  URL_CAMPAIGNS,
  URL_PRICING,
  URL_CAMPAIGN_CONFIGURATION_ID,
  URL_CAMPAIGN_MODULES_ID,
  URL_ACCOUNT,
  URL_SUPPORT_AND_HELP,
  URL_CAMPAIGN_METRICS_ID,
  URL_WIZARD_FILE,
  URL_CAMPAIGN_RECOPILATOR,
  URL_CAMPAIGN_RECOPILATOR_ID,
  URL_CAMPAIGN_BUY_AUDIENCE_ID,
  URL_CAMPAIGN_INVITE_AUDIENCE_ID
} from '../config/urls';

const mapStateToProps = (state, ownProps) => ({
  userData: state.user.userData,
  testsData: state.user.testsData,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  setTestsData: val => dispatch(setTestsData(val)),
  setRedirect: val => dispatch(setRedirect(val)),
  showNotification: val => dispatch(showNotification(val)),
  dispatch
})

class TopBar extends React.Component {
  _mount = true;

  constructor(props) {
    super(props);
    this.state = {
      showUserOptions: false,
      showAddNewModal: false,
      AddTestLoading: false,
      newTestName: "",
      newTestLang: "es",
      newTestType: "generic"
    };
  }

  componentWillMount() {
    const lang = localStorage.getItem('lang') || "es";
    const campaignTemplates = lang === "es" ? newCampaignTemplateES : newCampaignTemplateEN;
    this.setState({ newTestName: campaignTemplates.name });
  }

  componentDidMount() {
    window.addEventListener('click', (e) => {
      let closePopup = true;

      Array.from(document.getElementsByClassName('btn-open-popup')).forEach(element => {
        if (element.contains(e.target)){
          closePopup = false;
        }
      });

      if (this._mount && closePopup)
        this.setState({ showUserOptions: false });
    });
  }

  componentWillUnmount() {
    this._mount = false;
  }

  loggout() {
    localStorage.clear();
    const auth = new SounditiAuth();
    auth.logOut();
    window.Froged('logout');
    window.location.reload();
  }

  toggleUserOptions() {
    const { showUserOptions } = this.state;
    this.setState({ showUserOptions: !showUserOptions });
  }

  onInputChange(val) {
    this.setState(val);
  }

  addNewTest() {
    this.setState({ showAddNewModal: true });

    /*
    , () => {
      console.log(this.state.newTestName);
      if (this.refs.newTestName)
        this.refs.newTestName.refresh();

      if (this.refs.newTestLang)
        this.refs.newTestLang.refresh();
    }
    */
  }

  async createCampaign() {
    const { userData, newTestName, newTestLang, newTestType } = this.state;

    try {
      this.setState({ AddTestLoading: true });
      const lang = localStorage.getItem('lang') || "es";
      const campaignTemplates = lang === "es" ? { ...newCampaignTemplateES } : { ...newCampaignTemplateEN };

      campaignTemplates.name = newTestName;
      campaignTemplates.lang = newTestLang;
      campaignTemplates.type = newTestType;

      const campaignAccess = new CampaignAccess();
      const newCampaign = await campaignAccess.createCampaign(campaignTemplates);

      postActionGTMCampaing("GTM_new_campaign", newCampaign.campaignId, userData);

      await this.refreshTestsData();

      this.goCampaignModules(newCampaign);

      this.setState({ showAddNewModal: false, AddTestLoading: false, newTestName: newCampaignTemplateES.name, newTestLang: "es" });
    } catch (error) {
      this.setState({ AddTestLoading: false });
      showNotification("genericError");
    }
  }

  async refreshTestsData() {
    const { setTestsData } = this.props;
    const campaignAccess = new CampaignAccess();
    const refreshedTestsData = await campaignAccess.getCampaigns();
    setTestsData(refreshedTestsData);
  }

  goSupport() {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_SUPPORT_AND_HELP });
  }

  goAccount() {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_ACCOUNT });
  }

  goTests() {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_CAMPAIGNS });
  }

  goPricing() {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_PRICING });
  }

  goRecopilator(campaign) {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_CAMPAIGN_RECOPILATOR_ID.replace('[var1]', campaign.campaignId) });
  }

  goBuyAudience(campaign) {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_CAMPAIGN_BUY_AUDIENCE_ID.replace('[var1]', campaign.campaignId) });
  }

  goInviteAudience(campaign) {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_CAMPAIGN_INVITE_AUDIENCE_ID.replace('[var1]', campaign.campaignId) });
  }

  goCampaignModules(campaign) {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_CAMPAIGN_MODULES_ID.replace('[var1]', campaign.campaignId) });
  }

  goCampaignConfiguration(campaign) {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_CAMPAIGN_CONFIGURATION_ID.replace('[var1]', campaign.campaignId) });
  }

  goMetrics(campaign) {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_CAMPAIGN_METRICS_ID.replace('[var1]', campaign.campaignId) });
  }

  goWizardFile() {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_WIZARD_FILE });
  }

  render() {
    const { userData, location, t } = this.props;
    const { showUserOptions, showAddNewModal, AddTestLoading, newTestName, newTestLang, newTestType } = this.state;
    let username = userData && userData.email ? userData.email : "";
    let subscriptionID = '';

    if (userData && userData.data && userData.data.username)
      username = userData.data.username;

    if (userData && userData.subscription && userData.subscription.subscriptionId)
      subscriptionID = userData.subscription.subscriptionId;

    return (
      <>
        <ModalDialog
          name="TopBar_Add_New"
          showModal={showAddNewModal}
          loading={AddTestLoading}
          closeModal={e => { this.setState({ showAddNewModal: false }) }}
          onConfirm={() => { this.createCampaign() }}
        >
          <Input
            readOnly={AddTestLoading}
            placeholder=""
            name="newTestName"
            label={t('TopBar_Add_New_Input_Name')}
            value={newTestName}
            ref="newTestName"
            onChange={val => this.onInputChange(val)}
          />
          <Select
            readOnly={AddTestLoading}
            name="newTestLang"
            label={t("TopBar_Add_New_Input_Lang")}
            value={newTestLang}
            ref="newTestLang"
            onChange={val => this.onInputChange(val)}
            options={[
              { "value": "es", "label": t("Account_General_Lang_ES") },
              { "value": "en", "label": t("Account_General_Lang_EN") },
            ]}
          />
          {subscriptionID === '714bc456-3caa-42df-b57f-f7fb3cb30c4b' &&
            <Select
              readOnly={AddTestLoading}
              name="newTestType"
              label={t("TopBar_Add_New_Input_Type")}
              value={newTestType}
              ref="newTestType"
              onChange={val => this.onInputChange(val)}
              options={[
                { "value": "generic", "label": t("TopBar_Add_New_Select_Type_Generic") },
                { "value": "film", "label": t("TopBar_Add_New_Select_Type_Film") },
              ]}
            />
          }
        </ModalDialog>
        <div className="screen-topbar">
          <div className="row">
            <div className="left-content one-line">
              <img className="logo" src="/assets/img/main-logo.png" alt="Company logo" onClick={() => this.goTests()}/>
              <div className="main-links">
                <Link inline className={location.pathname === URL_CAMPAIGNS ? "active" : ""} onClick={() => this.goTests()}>
                  <T text="TopBar_My_Tests" />
                </Link>
                {/*
                <Link inline className={location.pathname === URL_PRICING ? "active" : ""} onClick={() => this.goPricing()}>
                  <T text="TopBar_Plans_And_Prices" />
                </Link>
                */}
              </div>
            </div>
            <div className="right-content">
              <div className="main-buttons">
                {/*
                <Link main className="featured" onClick={() => this.goPricing()}>
                  <T text="TopBar_Change_Plan" />
                </Link>
                */}
                <Link main className="white" onClick={() => this.addNewTest()}>
                  <T text="TopBar_Create_Test" />
                </Link>
              </div>
              <div className="user-options">
                <Link className="btn-open-popup" inline onClick={() => this.toggleUserOptions()}>
                  <div className="user-email">{username}</div>
                  <i className="icon icon-down-open-1"></i>
                </Link>
                {showUserOptions && (
                  <div className="user-options-menu" ref={this.wrapperRef}>
                    <div><Link inline onClick={() => { this.goAccount() }}><T text="TopBar_Submenu_My_Account" /></Link></div>
                    <div><Link inline onClick={() => { this.goSupport() }}><T text="TopBar_Submenu_Support_And_Help" /></Link></div>
                    <div className="separator"></div>
                    <div><Link inline onClick={() => { this.loggout() }}><T text="TopBar_Submenu_Close_Session" /></Link></div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default compose(
  withTranslation('translations', { withRef: true }),
  connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })
)(TopBar);
